"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutopayCategory = void 0;
var AutopayCategory;
(function (AutopayCategory) {
    AutopayCategory["STATEMENT_BALANCE"] = "STATEMENT_BALANCE";
    AutopayCategory["CURRENT_BALANCE"] = "CURRENT_BALANCE";
    AutopayCategory["MINIMUM_DUE"] = "MINIMUM_DUE";
    AutopayCategory["CUSTOM_AMOUNT"] = "CUSTOM_AMOUNT";
    AutopayCategory["BI_MONTHLY_CURRENT_BALANCE"] = "BI_MONTHLY_CURRENT_BALANCE";
})(AutopayCategory || (exports.AutopayCategory = AutopayCategory = {}));
